<template>
  <div class="agent-list">
    <div class="opreationBox"></div>
    <div class="tableBox">
      <el-table
        v-loading="loading"
        :height="tableH"
        :data="dataList"
        border
        style="width: 100%"
      >
        <el-table-column header-align="center" prop="name" label="会员微信名" />
        <el-table-column header-align="center" prop="createTime" label="创建时间" />
        <el-table-column
          header-align="center"
          align="center"
          label="公众号状态"
        >
          <template slot-scope="scope">
            <span v-text="scope.row.isSubscribe?'已关注':'未关注'" :style="{color:scope.row.isSubscribe?'#67c23a':'#f56c6c'}"></span>
          </template>
        </el-table-column>
        <el-table-column header-align="center" prop="enterpriseName" label="所属战略合伙人" />
        <el-table-column header-align="center" prop="parentName" label="所属二级合伙人" />
        <el-table-column
          header-align="center"
          align="center"
          fixed="right"
          label="操作"
          width="130"
        >
          <template slot-scope="scope">
            <el-button
              @click="lookQues(scope.row)"
              size="mini"
              plain
            >
              查看问卷详情
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pageBox">
      <el-pagination
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageObj.PageIndex"
        :page-sizes="[2, 4, 10, 20, 50, 100]"
        :page-size="pageObj.PageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageObj.total"
      />
    </div>
    <questionnaire-dialog
      v-if="dialogDesVisible"
      :showDes.sync="dialogDesVisible"
      :desObj="desObj" />
  </div>
</template>

<script>
  import { getAgentChildrenPage as getList } from 'api/request'
  import { SetTableH } from '../../../utils/utils'
  import questionnaireDialog from './component/questionnaireDialog'
  export default {
    components: {
      questionnaireDialog
    },
    data() {
      return {
        loading: false,
        dataList: [],
        tableH: '250',
        pageObj: {
          total: 0,
          PageIndex: 1,
          PageSize: 10
        },
        desObj: null,
        dialogDesVisible: false
      }
    },
    methods: {
      async getList() {
        const params = {
          PageIndex: this.pageObj.PageIndex,
          PageSize: this.pageObj.PageSize,
          partnerId:  sessionStorage.getItem('uId')
        }
        this.loading = true
        let data = await getList(params)
        if (data) {
          this.dataList = data.rows
          this.pageObj.total = data.total
          this.loading = false
        }
      },
      handleSizeChange(val) {
        this.pageObj.PageSize = val
        this.getList()
      },
      handleCurrentChange(val) {
        this.pageObj.PageIndex = val
        this.getList()
      },
      lookQues(data) {
        this.desObj = data
        this.dialogDesVisible = true
      },
    },
    created() {
      this.getList()
    },
    mounted() {
      SetTableH(this)
    },
  }
</script>

<style scoped lang="scss">
  .agent-list{
    .pageBox {
      margin-top: 20px;
      text-align: right;
    }
  }
</style>
